module.exports = __webpack_public_path__ + "img/medivac.93687d91.svg";